<template>
  <template repeat.for="line of model.message.split('\n')">${line}<br if.bind="!$last" /></template>
  <div if.bind="detailsPresenter">
    <a href="#" click.delegate="detailsPresenter(model)">Show error details</a>
  </div>
</template>
